import React from 'react';
import { render, screen } from '@testing-library/react';
import '@testing-library/jest-dom';
import New from './new';

describe('New', () => {
  test('renders New component', () => {
    render(<New />);

    // screen.debug();
    expect(screen.getByText('チケットマスタ作成')).toBeInTheDocument();
  });
});
